const createField = (id, label, type) => ({
  id,
  name: id,
  label,
  type,
});

export const field = [
  createField("deviceType", "Device Type", "select"),
  createField("name", "Device Name", "input"),
  createField("cameraType", "Camera Type", "Camera"),
  createField("streamUrl", "Stream URL", "Camera"),
  createField("deviceMake", "Device Make", "input"),
  createField("serialNumber", "Serial Number", "input"),
  createField("dateInstalled", "Date Installed", "datePicker"),
  createField("macAddress", "MAC Address", "input"),
  createField("ipAddress", "IP Address", "input"),
  createField("topicName", "Topic Name", "input"),
  createField("triggerBy", "Trigger By", "multiSelect"),
];
